<p-dialog
  [(visible)]="visible"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  [style]="{ 'max-width': '90vw', 'min-width': '70vw' }"
>
  <ng-template pTemplate="header">
    <div class="flex justify-start items-start flex-col">
      <h1 class="text-xl"><b>Añadir nuevo recurso</b></h1>
      <small class="mb-4 italic opacity-80">
        <b>
          Aquí podrá agregar imágenes, videos o pdf para colocar en la visual
          del curso. El mismo se va a insertar en el editor, como un frame
          embebido, en el caso de los videos e imágenes, o un link, en el caso
          de los pdf.
        </b>
      </small>
    </div>
  </ng-template>

  <c-res-files
    (emitirImagen)="add($event)"
    [adjuntos]="adjuntos"
    (borrarImagen)="remove($event)"
  />

  <div class="w-full my-4">
    <p class="text-center">Ó</p>
  </div>
  <div class="w-full mb-4">
    <p class="text-center text-blue-600">
      <b class="cursor-pointer" (click)="repo.open()">Revisar mi repositorio</b>
    </p>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end">
      <petrol-button variant="tertiary" (click)="close()">Cerrar</petrol-button>
    </div>
  </ng-template>
</p-dialog>

<c-modal-repo #repo (emitirAdjunto)="pushAdjunto($event)" />
